module.exports = "https://images.shiksha.ws/saassets/media/Arrow-ContentLoader.a52960f8.png";